import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
const json = {
  4: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/fpt_ai/Tieude-p22.mp3",
    autoPlay: true,
    video: "",
    // recorder: true,
    isHello:true,
    exerciseKey: "/img/FriendsPlus/Page22/Key/E4answerKey.jpg",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    inputSize: 81,
    // isTuLuan: true,
    textareaStyle: { width: 800, paddingTop: "5px" },
    titleQuestion: [
      {
        num: "",
        title: `
        <div style='margin-left:120px;font-size:30px;color:rgb(102 96 132)'>VIẾT ĐOẠN VĂN NÊU Ý KIẾN</div>
				`,
        color: "rgb(29,193,215)",
      },
    ],

    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    isEssay: true,
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `
        <span>Em hãy đọc và chỉnh sửa bài viết theo các ý: Cách mở đoạn, cách trình bày lí do, cách kết thúc, cách dùng từ đặt câu, cách thức trình bày đoạn văn. Sau khi đã hoàn thiện bài, em đọc soát và chỉnh sửa bài viết.</span><br>
        <video  src="Audios/fpt_ai/p22_e4.mp3" controls style="width: 100%; margin-top:10px; height: 2cm"></video>
            
        `,
      },
    ],
    questions: [
      {
        title: `
            <div style='width:20cm;border: 5px solid rgb(29,193,215);padding:5px 10px;border-radius:20px;box-shadow:0px 2px 3px 4px gray'>
              
              <b>Đề bài:</b> Viết đoạn văn nêu lý do yêu thích một câu chuyện về tình cảm gia đình mà em đã đọc hoặc đã nghe. <br>
             
            </div>   
          <div style='width:20cm;margin:20px 0px'>
           
              <b style='color:rgb(3, 103, 181)'>2.</b>&ensp; Đọc soát và chỉnh sửa bài viết.<br>
            <div style='width:25cm'>
              <span style='background:yellow; padding:6px 40px; text-align:center'>
                Cách mở đoạn
              </span>            
              <span style='background:rgb(227 199 202); padding:6px 40px; text-align:center;margin:0px 10px'>
                Cách trình bày lí do
              </span>            
              <span style='background:rgb(204 218 221); padding:6px 40px; text-align:center'>
                Cách kết thúc
              </span>            
            </div>
            <div style='width:20cm;margin:20px 70px'>
              <span style='background:yellow; padding:6px 40px; text-align:center;margin:0px 10px'>
                Cách dùng từ
              </span>            
              <span style='background:rgb(227 199 202); padding:6px 40px; text-align:center'>
                Cách thức trình bày đoạn văn
              </span>            
                      
            </div>
            
            <div style='margin-left: 350px;font-weight:bold'>
              Bài làm:
            </div>
            <div >
              <textarea id='0' rows='8'></textarea>
            </div> 
        
        `,
        answer: [""],
      },
    ],
  },
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/fpt_ai/p22_e1.mp3",
    autoPlay: true,
    video: "",
    recorder: true,
    exerciseKey: "/img/FriendsPlus/Page22/Key/E1answerKey.jpg",
    component: T6,
    // textAlign: "center",
    hideBtnFooter: true,
    // maxLength: 1,
    inputSize: 81,
    stylesTextInput: { fontSize: "22px", height: 29 },
    textareaStyle: { width: 800 },
    titleQuestion: [
      {
        num: "",
        title: `
        
				`,
        color: "rgb(29,193,215)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `
        <span>Em tìm đọc câu chuyện về người có năng khiếu nổi bật qua sách báo, internet,… </span><br>
        <video  src="Audios/fpt_ai/p22_e1.mp3" controls style="width: 100%; margin-top:10px; height: 2cm"></video>
            
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    isEssay: true,
    questions: [
      {
        title: `
        <div style='position: relative'>
        <img src='/img/FriendsPlus/Page22/E1/1.jpg' style='height:15mm;margin-right:50px; height: 17mm' />
        <div style='font-weight:bold;position:absolute;top:7px; left:37px;font-size:30px;color:rgb(32 62 111)'>ĐỌC MỞ RỘNG</div>
          <div style='width:20cm;margin:20px 0px'>
            <div>
              <b style='color:rgb(3, 103, 181)'>1.</b>&ensp;Đọc câu chuyện về người có năng khiếu nổi bật.<br>
              <div style='display:flex;margin-left:50px'>
                  <b style='margin-right:20px;color:rgb(158 59 56)'>G.</b>
                  <div >
                    - Thần đồng đất Việt <br>
                    - Danh nhân thế giới
                  </div>
              </div>
                  <img src='/img/FriendsPlus/Page22/b.jpg' style='height:70mm' /> 
            </div>
           
        `,
        answer: [""],
      },
    ],
  },
  2: {
    unit: "Unit 2",
    id: "FP8-SB-demo-2023-U2-P29-E13",
    audio: "Audios/fpt_ai/p22_e2.mp3",
    autoPlay: true,
    isTuLuan:true,
    video: "",
    isHiddenCheck:true,
    component: T6,
    stylesTextInput:{fontWeight:400,fontSize: 20,paddingTop:15},
    exerciseKey: "/img/FriendsPlus/Page22/Key/E2answerKey.png",
    titleQuestion: [
      {
        num: "",
        title: `
        
				`,
        color: "rgb(29,193,215)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `
        <span>Em tìm đọc câu chuyện và điền vào phiếu thích hợp. </span><br>
        <video  src="Audios/fpt_ai/guide/p22_e2.mp3" controls style="width: 100%; margin-top:10px; height: 2cm"></video>
            
        `,
      },
    ],
    textareaStyle: {
      // background: 'none',
      width: 1100,
      fontSize: 20,
      paddingTop: 5,
    },
    RateStar:
      { 
        countStar:5,
        defaultValue:0,
        style:{
          display:'flex',
          justifyContent:'center',
          marginTop:"-115px",
          marginLeft:"100px",
        },
        styleColor:{
          fontSize:40,
          height:"70px",
        },
        styleFonts:{
          fontWeight:"bold",
          marginTop:10,
          marginLeft:20,
          fontSize:30,
          
        }
      },
    // isHello:true,
    questions: [
      {
        title: `
      <img src='/img/FriendsPlus/Page22/E1/1.jpg' style='height:15mm; height: 17mm; margin-left: -206px' />
      <div style='font-weight:bold;position:absolute;top:7px; left:37px;font-size:30px;color:rgb(32 62 111); margin-left: -206px'>ĐỌC MỞ RỘNG</div>
        <div style='width:20cm;margin:20px 0px'>
          <div>
            <b style='color:rgb(3, 103, 181); margin-left: -200px'>2.</b>&ensp;Viết phiếu đọc sách theo mẫu.<br>
          </div>
          <div style='; display: flex; flex-direction: column; width:296mm; margin-left: -150px'>
      <div style="text-align: center; background-color: rgb(55,183,236); border: 2px solid black; display: table-caption; color: white; font-weight: 700">
      PHIẾU ĐỌC SÁCH
      </div>
      <div style='display: flex'>
        <div style="border-left: 2px solid black; border-right: 2px solid black; padding-left: 15px;  padding: 10px"><div>Tên câu chuyện:</div> <input id='0' width='550px'></input></div>
        <div style="padding-left: 15px;  padding: 10px">Tác giả:<br> <input id='1' width='300px'></input></div>
        <div style="border-right: 2px solid black; border-left: 2px solid black;  padding-left: 15px;  padding: 10px">Ngày đọc:<br> <input id='2' width='177px'></input></div>

      </div>     
      <div style="border: 2px solid black; padding-left: 15px; padding: 10px;">
        Tên nhân vật:<input id='3' width='1100px'></input>
      </div>
      <div style="border: 2px solid black; border-top:none; padding-left: 15px; padding: 10px;">
        <span>Năng khiếu nổi bật của nhân vật:</span><br>
      
         <textarea id='4' rows='3'></textarea>
      </div>
      <div style="display:flex;border: 2px solid black; border-top:none;  padding-left: 15px; padding: 10px;">
      Mức độ yêu thích:  
      
      </div>  
    

        `,
        answer: ["","","","",""],
      },
    ],
  },
  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/fpt_ai/p22_e3.mp3",
    autoPlay: true,
    video: "",
    isTuLuan:true,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page22/Key/E3answerKey.png",
    component: T6,
    // maxLength: 1,
    inputSize: 81,
    stylesTextInput: { fontSize: "22px", height: 29 },
    textareaStyle: { width: 900, paddingTop: 5 },
    titleQuestion: [
      {
        num: "",
        title: `
        
				`,
        color: "rgb(29,193,215)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `
        <span>Em trao đổi với bạn về nội dung câu chuyện đã đọc theo gợi ý sau: Nội dung câu chuyện nói về điều gì? Nhân vật chính trong truyện là ai? Nhân vật đó có năng khiếu gì nổi bật? Em hãy nêu tình cảm, cảm xúc của mình về nhân vật đó,…).<br> Gõ các nội dung em định trao đổi với bạn vào các dòng trống. </span><br>
        <video  src="Audios/fpt_ai/guide/p22_e3.mp3" controls style="width: 100%; margin-top:10px; height: 2cm"></video>
            
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    questions: [
      {
        title: `
        <div style='position: relative'>
        <img src='/img/FriendsPlus/Page22/E1/1.jpg' style='height:15mm;margin-right:50px; height: 17mm' />
        <div style='font-weight:bold;position:absolute;top:7px; left:37px;font-size:30px;color:rgb(32 62 111)'>ĐỌC MỞ RỘNG</div>
          
          <div style=''> 
            <div>
              <b style='color:rgb(3, 103, 181); '>3.</b>&ensp;Trao đổi với bạn về nội dung câu chuyện mà em đã đọc.<br>
            </div>
          <textarea id='0' rows='5'></textarea>
          </div>
        `,
        answer: [""],
      },
    ],
  },
  5: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/fpt_ai/p22_e5.mp3",
    autoPlay: true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page22/Key/E5answerKey.png",
    component: T6,
    // maxLength: 1,
    inputSize: 81,
    isHello:true,
    // isTuLuan: true,
    stylesTextInput: { fontSize: "22px", height: 29 },
    textareaStyle: { width: 800,paddingTop:5 },
    titleQuestion: [
      {
        num: "",
        title: `
        
				`,
        color: "rgb(29,193,215)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `
        <span>
        Em hãy viết lại câu chuyện định kể với người thân vào các dòng trống theo các gợi ý sau:<br>
        – Tác giả mà em yêu thích là ai?<br>
        – Em định kể câu chuyện nào?<br>
        – Nội dung của câu chuyện ra sao?<br>
        – Cảm xúc/ tình cảm của em như thế nào?

        </span><br>
        <video  src="Audios/fpt_ai/guide/p22_e5.mp3" controls style="width: 100%; margin-top:10px; height: 2cm"></video>
            
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    questions: [
      {
        title: `
        <div style='position: relative'>
        <img src='/img/FriendsPlus/Page22/E1/1.jpg' style='height:15mm;margin-right:50px; height: 17mm' />
        <div style='font-weight:bold;position:absolute;top:7px; left:37px;font-size:30px;color:rgb(32 62 111)'>ĐỌC MỞ RỘNG</div>
          
          <div style='display: flex'>
            <img src='/img/FriendsPlus/images/d.jpg' style='height:15mm;margin-right:50px' /> 
            <div>
              Kể với người thân một câu chuyện của tác giả mà em yêu thích.
            </div>
            
          </div><textarea id='0' rows='5'/></textarea>
        `,
        answer: [""],
      },
    ],
  },
};

export default json;
